import { render, staticRenderFns } from "./perfectInBlack.vue?vue&type=template&id=64fc3159"
import script from "./perfectInBlack.vue?vue&type=script&lang=js"
export * from "./perfectInBlack.vue?vue&type=script&lang=js"
import style0 from "./perfectInBlack.vue?vue&type=style&index=0&id=64fc3159&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports